'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Institution = require('./Institution');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Institution).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Institution/index.js
// module id = 1212
// module chunks = 1